<div class="flex flex-col md:flex-row p-4 bgme rounded-lg gap-4 max-w-full overflow-hidden">

  <div class="flex flex-col gap-2 justify-center px-2 shrink-0">
    <h1 class="text-xl m-0 font-bold text-zinc-800">Create New Form</h1>
    <p class="text-sm text-zinc-500 m-0">You can create a new form with a template or start with a blank form.</p>
  </div>

  <div class="template-scroll relative min-w-0 w-full md:flex-1 flex flex-row gap-[10px]">
    <div
      class="bg-white cursor-pointer rounded-md overflow-hidden p-3 md:p-[15px] w-[120px] sm:w-[140px] md:w-[150px] text-center shrink-0 flex flex-col items-center justify-center"
      (click)="createCollectionTemplate()">
      <ion-icon name="add-outline" class="text-black text-5xl md:text-[5rem]"></ion-icon>
      <button type="button"
        class="w-full h-[40px] rounded-md border border-zinc-300 bg-transparent px-[5px] text-sm font-medium text-zinc-900">
        Start Blank
      </button>
    </div>

    <div class="template-scroll__viewport relative min-w-0 flex-1">
      @if (canScrollLeft) {
      <button type="button" class="template-scroll__btn template-scroll__btn--left" aria-label="Scroll left"
        (click)="scrollTemplates('left')">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
      }
      @if (canScrollRight) {
      <button type="button" class="template-scroll__btn template-scroll__btn--right" aria-label="Scroll right"
        (click)="scrollTemplates('right')">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
      }
      <div #templateScrollTrack
        class="template-scroll__track flex flex-row overflow-x-auto whitespace-nowrap gap-2 h-full"
        (scroll)="onTemplateScroll()">
        @for (mt of masterTemplates; track mt._id) {
        <div
          class="bg-white rounded-md overflow-hidden p-3 md:p-4 w-[120px] sm:w-[140px] md:w-[150px] shrink-0 flex flex-col justify-between min-w-0 h-full">
          <p class="capitalize w-full text-left whitespace-normal break-words">{{ mt.template.purpose }}</p>
          <button type="button"
            class="w-full h-[40px] rounded-md border border-solid border-zinc-300 bg-transparent px-[5px] text-sm font-medium text-zinc-900"
            (click)="createTemplate(mt._id)">
            Create
          </button>
        </div>
        }
        <div class="w-[10px] shrink-0"></div>
      </div>
    </div>
  </div>
</div>